import { createSelector } from '@reduxjs/toolkit';
import {
  getLocationsSelectorArgs,
  getRegionSelector,
} from './getRegionSelector';
import { filterNotEmpty } from '../../../shared/ArrayUtil';

export const getDevicesByRegionSelector = createSelector(
  [getLocationsSelectorArgs, getRegionSelector],
  (locationsData, region) =>
    locationsData.data?.devices.filter(filterNotEmpty) ?? []
);

export const getAllDevicesSelector = createSelector(
  [getLocationsSelectorArgs],
  (locationsData) => locationsData.data?.devices ?? []
);
